import { z } from 'zod';
import { GeoLocationSchema } from './device.js';
// ---------------------------------------------------------------------------
// 농장 정보 스키마
// ---------------------------------------------------------------------------
export const FarmInfoSchema = z.object({
    id: z.string().uuid(),
    ownerId: z.string().uuid(),
    name: z.string().min(1).max(100),
    description: z.string().max(500).nullable().optional(),
    location: GeoLocationSchema.nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deviceCount: z.number().int().nonnegative().optional(),
    cropType: z.string().max(100).nullable().optional(),
    icon: z.string().max(40).nullable().optional(),
});
// ---------------------------------------------------------------------------
// 농장 생성/수정 요청 스키마
// ---------------------------------------------------------------------------
export const CreateFarmSchema = z.object({
    name: z.string().min(1, '농장 이름을 입력하세요').max(100),
    description: z.string().max(500).optional(),
    location: GeoLocationSchema.optional(),
    cropType: z.string().max(100).optional(),
    icon: z.string().max(40).optional(),
});
export const UpdateFarmSchema = CreateFarmSchema.partial().extend({
    // 위치는 null을 보내 삭제할 수 있다.
    location: GeoLocationSchema.nullable().optional(),
});
//# sourceMappingURL=farm.js.map